
export const API_URL = "https://admin.shopsaran.com/api/api";
export const API_URL2 = "https://admin.shopsaran.com/api";
export const AUTH_TOKEN = "741101459d86e4b13a37cefa9faeb9afc48862e94306b58cbcd5eb4780c8fbcfa55bc01dd9ec74ca7afc9c28e3321f3db331f4aeb95b30d5e793bb26537ef132f671e7593ff8c663efe4ef68fe9903bd3a385362ead512e6032966e6c0588b2bdd1f6179b0ba2ef02d392a62ced19b2bd8e5bffccaf3c0408dbf4a99d0235194";
export const BEARER = "Bearer";
export const EMAIL_FROM = "admin@shopsaran.com";
export const EMAIL_TO = "saran.egy@gmail.com";
export const WEBSITE_URL = "https://shopsaran.com";